/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {data} from "./config/create-asset-description";

const MODULE_NAME = "AssetDescriptionService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class CreateAssetDescriptionService {
    private static instance: CreateAssetDescriptionService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): CreateAssetDescriptionService {
        if (!CreateAssetDescriptionService.instance) {
            CreateAssetDescriptionService.instance = new CreateAssetDescriptionService(
                props
            );
        }
        return CreateAssetDescriptionService.instance;
    }

    async getCreateAssetDescription() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            
            return data;
        } catch (err) {
            console.log(`error in Create asset Desc Serivce`, err)
        }
    }
}
